import { ClickAwayListener, Grow, Paper, Popper } from '@mui/material';

import PropTypes from 'prop-types';
import React from 'react';
import noop from 'lodash/noop';

/**
 * Shared flyout shell for the sidebar's utility menus (org switcher, notifications,
 * account). Mirrors the collapsed product menu look — a Popper with a small gap
 * between the rail and the menu — so every sidebar-anchored menu positions and reads
 * the same way. Content is caller-provided.
 */
const SidebarFlyout = props => {
    const {
        anchorEl,
        children,
        onClose = noop,
        onMouseEnter = noop,
        onMouseLeave = noop,
        open,
        placement = 'right-start',
    } = props;
    const isRight = placement.startsWith('right');
    const isTop = placement.startsWith('top');
    // Gap between the menu and its trigger, on whichever side it opens.
    const gapSx = isRight
        ? { marginLeft: '14px' }
        : isTop
          ? { marginBottom: '8px' }
          : { marginTop: '8px' };
    const transformOrigin = isRight ? 'left top' : isTop ? 'center bottom' : 'top center';

    const handleClickAway = event => {
        if (anchorEl && anchorEl.contains(event.target)) {
            return;
        }
        onClose();
    };

    return (
        <Popper
            open={Boolean(open) && Boolean(anchorEl)}
            anchorEl={anchorEl}
            placement={placement}
            transition
            modifiers={[{ name: 'computeStyles', options: { gpuAcceleration: false } }]}
            sx={{ zIndex: theme => theme.zIndex.tooltip + 1 }}
        >
            {({ TransitionProps }) => (
                <Grow {...TransitionProps} style={{ transformOrigin }}>
                    <Paper
                        elevation={8}
                        sx={gapSx}
                        onMouseEnter={onMouseEnter}
                        onMouseLeave={onMouseLeave}
                    >
                        <ClickAwayListener onClickAway={handleClickAway}>
                            <div>{children}</div>
                        </ClickAwayListener>
                    </Paper>
                </Grow>
            )}
        </Popper>
    );
};

SidebarFlyout.propTypes = {
    anchorEl: PropTypes.object,
    children: PropTypes.node,
    onClose: PropTypes.func,
    onMouseEnter: PropTypes.func,
    onMouseLeave: PropTypes.func,
    open: PropTypes.bool,
    placement: PropTypes.string,
};

export default SidebarFlyout;
